<template>
  <div class="weight-loss-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">
        Controle de Peso / Redução de Gordura Não Cirúrgica
      </h2>
      <p>
        Na Diverse Care Now, oferecemos programas de emagrecimento
        supervisionados por médicos, que combinam medicação moderna com suporte
        de estilo de vida. O objetivo não é apenas perder peso — é conquistar
        saúde duradoura, equilíbrio e confiança.
      </p>
      <h3>O que incluímos</h3>
      <ul>
        <li>
          Opções de medicação — Terapias medicamentosas supervisionadas por médicos,
          prescritas quando apropriado e sempre sob supervisão
          médica.
        </li>
        <li>
          Planos personalizados — cada paciente recebe um programa adaptado ao
          histórico de saúde, metas e necessidades individuais.
        </li>
        <li>
          Nutrição & suporte ao estilo de vida — orientações em planejamento
          alimentar, controle de porções e rotinas saudáveis.
        </li>
        <li>
          Monitoramento contínuo — consultas mensais e ajustes de dose para
          garantir segurança e eficácia.
        </li>
      </ul>
      <p>
        "Mais do que emagrecimento, nossos programas são feitos para restaurar
        sua saúde, energia e autoconfiança — sempre com acompanhamento médico
        especializado."
      </p>
    </div>
    <div class="wl-videos">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          margin-bottom: 1.5rem;
        "
        src="https://www.youtube.com/embed/L1P7TDXi-3g"
        title="YouTube Shorts: Weight Loss 1"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/VVgrgvhakKY"
        title="YouTube Shorts: Weight Loss 2"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeightLossContentPtBR",
};
</script>

<style scoped>
.weight-loss-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.wl-videos {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.wl-videos iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .weight-loss-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .wl-videos {
    align-self: center;
  }

  .wl-videos iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .wl-videos iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
